import Container from "hardcover-ui/components/Container";
import PageWrapper from "components/ui/PageWrapper";
import JoinOrLoginForm from "components/join/JoinOrLoginForm";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";

function JoinPage({tab}:{tab: "Join" | "Login"}) {
  return (
    <PageWrapper>
      <Container variant="layout">
        <JoinOrLoginForm tab={tab} />
      </Container>
    </PageWrapper>
  );
}

JoinPage.layout = DefaultLayoutWrapper;
export default JoinPage;
